module.exports = __webpack_public_path__ + "img/star-map.6ccd8a3.svg";